var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 156,
    viewBox: "0 0 141 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.796 206.974L12.8355 202.675C7.59826 202.363 3.8462 197.594 4.78422 192.435L31.4395 43.0559C32.3775 37.8968 36.5986 34.0666 41.7577 33.5194L112.031 26.7188C117.737 26.1716 122.427 31.1744 121.489 36.8807L94.912 197.282C93.974 203.144 88.7368 207.365 82.796 206.974Z",
    fill: "#F8AB5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9659 206.506L9.00545 202.206C3.76819 201.894 0.0161254 197.126 0.954143 191.966L27.6094 42.5872C28.5475 37.4281 32.7686 33.5978 37.9277 33.0507L108.201 26.25C113.907 25.7029 118.597 30.7056 117.659 36.4119L91.082 196.813C90.144 202.675 84.9067 206.818 78.9659 206.506Z",
    fill: "#FFE779"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.473 122.084L41.7578 123.96C38.9438 124.039 36.8332 121.459 37.3023 118.723L45.1972 73.7764C45.6662 71.1969 47.7768 69.3208 50.3563 69.0863L156.665 61.9731C160.261 61.7385 163.231 64.9434 162.606 68.5392L154.789 117.394C154.554 120.052 152.209 122.084 149.473 122.084Z",
    fill: "#F8AB5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.592 194.546L29.8761 189.856C27.2184 189.699 25.186 187.276 25.655 184.618L33.7845 138.577C34.2535 135.92 36.5985 133.887 39.3344 133.887L145.799 133.027C149.317 133.027 151.975 136.154 151.428 139.593L143.454 189.856C142.985 192.67 140.406 194.702 137.592 194.546Z",
    fill: "#F8AB5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9678 51.5762L116.33 44.3848",
    stroke: "#F8AB5D",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9307 40.7121L64.1921 41.4156C63.4886 41.4937 63.0977 40.9466 63.1759 40.1649C63.3322 39.3832 63.9576 38.7579 64.6611 38.6797L72.3998 37.9762C73.1033 37.898 73.5723 38.4452 73.4159 39.2269C73.2596 40.0085 72.5561 40.6339 71.9307 40.7121Z",
    fill: "#22272E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0898 40.2433C76.3863 40.3215 75.9172 39.7743 76.0736 38.9926C76.2299 38.2109 76.8553 37.5856 77.5588 37.5074C78.2623 37.4293 78.7313 37.9764 78.575 38.7581C78.4968 39.5398 77.7933 40.2433 77.0898 40.2433Z",
    fill: "#22272E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164.169 45.5568L134.387 47.8237C133.293 47.9019 132.433 46.9638 132.667 45.9477L135.638 27.8908C135.794 26.7965 136.732 25.9366 137.826 25.8585L167.296 22.7317C168.546 22.5754 169.563 23.6697 169.406 24.9204L166.514 43.5244C166.201 44.6188 165.263 45.4786 164.169 45.5568Z",
    stroke: "#6DAFA7",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.419 26.3279L149.395 34.6919C150.099 35.1609 151.037 35.1609 151.74 34.6919L168.625 23.123",
    stroke: "#6DAFA7",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7981 79.3253L5.33147 80.6541L1.73576 82.9992C0.87591 83.5463 -0.140285 82.8428 0.0160514 81.8266L3.84631 60.5649C4.15898 58.8452 5.56598 57.5945 7.28568 57.4382L32.7685 55.484C34.41 55.3277 35.8171 56.8128 35.5044 58.4544L32.2213 77.0584C31.9868 78.3873 30.9707 79.2471 29.7981 79.3253Z",
    fill: "#6DAFA7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61475 63.6922L29.2511 62.207",
    stroke: "#22272E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67627 68.9285L28.3127 67.5215",
    stroke: "#22272E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73877 74.0882L17.526 73.4629",
    stroke: "#22272E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.689 117.315L35.9732 119.191C33.1591 119.269 31.0486 116.689 31.5176 113.954L39.4126 69.0069C39.8816 66.4274 41.9921 64.5513 44.5717 64.3168L150.88 57.2035C154.476 56.969 157.446 60.1739 156.821 63.7696L149.004 112.625C148.692 115.282 146.425 117.315 143.689 117.315Z",
    fill: "#22272E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8794 83.3127C63.3322 86.5176 60.5182 89.2535 57.626 89.4099C54.7337 89.5662 52.8577 87.0648 53.4049 83.8599C53.952 80.655 56.7661 77.9191 59.6583 77.7628C62.5505 77.6065 64.4266 80.1079 63.8794 83.3127Z",
    fill: "#FFE779"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8468 103.87L49.0272 104.261C47.3075 104.339 45.9005 102.776 46.2132 101.056L46.4477 99.6493C47.4639 93.8649 52.4666 88.9403 57.7039 88.784C62.9411 88.5494 66.4587 93.1614 65.4425 99.024L65.1298 101.056C64.8172 102.62 63.4883 103.792 61.8468 103.87Z",
    fill: "#FFE779"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.12 83.8585L81.0759 86.2035C79.9816 86.2817 79.1217 85.2655 79.3562 84.2493L79.9034 80.8099C80.1379 79.6374 81.0759 78.7775 82.2484 78.6994L133.37 76.0417C134.465 75.9635 135.325 76.9015 135.09 77.9959L134.465 81.7479C134.308 82.9205 133.292 83.8585 132.12 83.8585Z",
    fill: "#6DAFA7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5287 95.4297L81.3103 97.8529L83.7336 98.2437L81.623 100.354L81.4667 103.09L79.4343 101.996L76.933 103.246L77.7146 100.511L76.3076 98.5564L78.8872 97.9311L80.5287 95.4297Z",
    fill: "#FFE779"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2538 95.0391L93.1136 97.4623L95.5368 97.8531L93.4263 99.9636L93.3481 102.7L91.1594 101.605L88.6581 102.856L89.4397 100.12L88.0327 98.0876L90.6123 97.5404L92.2538 95.0391Z",
    fill: "#FFE779"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M104.292 94.5684L105.151 96.9916L107.653 97.4606L105.464 99.5711L105.386 102.385L103.197 101.213L100.618 102.542L101.399 99.7275L99.9141 97.6951L102.65 97.0697L104.292 94.5684Z",
    fill: "#FFE779"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.564 94.0996L117.424 96.601L120.003 96.9918L117.815 99.1805L117.737 101.995L115.47 100.822L112.812 102.151L113.672 99.2587L112.108 97.3045L114.844 96.6792L116.564 94.0996Z",
    fill: "#FFE779"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M129.149 93.6309L130.009 96.1322L132.667 96.6013L130.4 98.7118L130.321 101.604L127.976 100.431L125.319 101.76L126.179 98.8681L124.615 96.8358L127.351 96.2104L129.149 93.6309Z",
    fill: "#FFE779"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M131.729 189.778L24.0919 185.01C21.4341 184.854 19.4018 182.43 19.8708 179.773L28.0003 133.732C28.4693 131.074 30.8143 129.041 33.5502 129.041L140.015 128.182C143.533 128.182 146.19 131.308 145.643 134.748L137.67 185.01C137.123 187.902 134.622 189.934 131.729 189.778Z",
    fill: "#22272E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3887 149.835C51.8415 153.118 49.0275 155.776 46.0571 155.698C43.1649 155.62 41.2888 152.962 41.836 149.679C42.3832 146.396 45.1972 143.816 48.0895 143.816C51.0598 143.895 53.014 146.552 52.3887 149.835Z",
    fill: "#FFE779"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1219 170.941L37.3023 170.55C35.6607 170.472 34.41 168.987 34.6445 167.346L34.9572 165.704C35.9734 159.763 40.9762 155.073 46.2135 155.151C51.4507 155.23 54.9683 160.154 53.8739 166.173L53.5612 168.127C53.3267 169.769 51.8416 170.941 50.1219 170.941Z",
    fill: "#FFE779"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.473 154.68L69.4295 153.977C68.4134 153.977 67.6317 153.039 67.788 152.023L68.4134 148.427C68.6479 147.176 69.6641 146.316 70.9148 146.316L122.037 146.707C123.053 146.707 123.835 147.645 123.678 148.661L123.053 152.57C122.818 153.742 121.724 154.68 120.473 154.68Z",
    fill: "#6DAFA7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.853 9.59995C128.681 8.27109 126.648 8.19292 125.398 9.36544C124.069 10.538 123.991 12.5703 125.163 13.821C126.336 15.1499 128.368 15.2281 129.619 14.0555C130.948 12.883 131.026 10.8506 129.853 9.59995Z",
    fill: "#22272E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M125.632 2.2526L125.085 1.62726C123.209 -0.405106 120.082 -0.56145 118.05 1.31458C116.018 3.19062 115.861 6.31734 117.737 8.34972L118.285 8.97506C118.91 9.67858 119.379 10.5384 119.613 11.4764C119.77 12.18 120.004 13.0398 120.239 13.8215C120.708 15.5412 122.74 16.1665 124.069 14.994L127.587 11.7891L131.104 8.58422C132.433 7.4117 131.964 5.22299 130.322 4.67582C129.541 4.36314 128.759 4.12864 128.056 3.89413C127.118 3.42513 126.336 2.95611 125.632 2.2526Z",
    fill: "#6DAFA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon1);
export default __webpack_public_path__ + "static/media/cardIcon1.651b5fb9ab77feb0b0adcddb00afdb79.svg";
export { ForwardRef as ReactComponent };